import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ClientInternalIdentificationNipInvalidWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.client.validation.internal-identification.invalid-nip');
    }
}
